<template>
  <div v-if="hasIteractions">
    <v-container v-if="!loadingChart">
      <v-row dense>
        <v-col cols="6" class="section-item-title"
          ><span class="section-item-title"> Interactions</span>
        </v-col>
        <v-col cols="2" class="section-stats-display"
          ><v-icon color="gray">schedule</v-icon
          ><span>{{ duration }}</span></v-col
        >
        <v-col cols="2" class="section-stats-display"
          ><v-icon color="gray">mdi-account</v-icon
          ><span>{{ uniqueAgentsCount }}</span></v-col
        >
      </v-row>
      <v-row dense>
        <horizontal-bar-chart
          style="position: relative; width:90%; height:30vh"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </v-row>
    </v-container>
    <log-dialog
      :headers="headers"
      :logData="logData"
      :showDialog="showDialog"
      :title="dialogTitle"
      :isLoading="loading"
      :csvFilename="csvFilename"
      :courseId="course.id"
    />
  </div>
</template>

<script>
import HorizontalBarChart from './HorizontalBarChart.vue'
import LogDialog from './LogDialog.vue'

import {
  getDuration,
  Multiset,
  roundToTwo,
  getRandomColorFromList,
  interactionTitle,
  interactionTableHeader,
  sortDataByDate,
  TOTAL_ITEMS,
  ellipsisLongText
} from '../Constants'
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    activities: {
      type: Array,
      required: true
    },
    course: {
      type: Object,
      required: true
    },
    duration: {
      type: String,
      required: true
    }
  },
  components: {
    HorizontalBarChart,
    LogDialog
  },
  data() {
    return {
      hasIteractions: false,
      interactionsData: null,
      chartData: {},
      chartOptions: {},
      uniqueAgentsCount: 0,
      loading: true,
      loadingChart: false,
      headers: [],
      logData: [],
      showDialog: false,
      dialogTitle: '',
      csvFilename: ''
    }
  },
  mounted() {
    this.loadingChart = true
    this.setData()
    this.fillChartData()
    this.loadingChart = false
  },
  methods: {
    onClickInteraction(event, array) {
      this.logData = []
      const lebel = array[0]._chart.tooltip._data.labels[array[0]._index]
      const metadata = array[0]._chart.tooltip._data.metadata

      const courseName = this.course.name.replace(/\s+/g, '_')
      this.dialogTitle = interactionTitle
      this.headers = interactionTableHeader
      this.csvFilename = courseName + '_interaction_section_log'
      this.loading = true
      this.showDialog = true

      const intData = _.find(metadata, {
        name: lebel
      })

      if (intData !== undefined && intData != null) {
        intData.interactions.forEach(element => {
          if (element.duration != null && element.duration !== undefined) {
            element.duration = getDuration(element.duration)
          }

          if (element.score != null && element.score !== undefined) {
            element.score = roundToTwo(element.score)
          }
          this.logData.push(element)
        })
      }
      this.logData = sortDataByDate(this.logData)
      this.loading = false
    },
    setData() {
      this.interactionsData = new Array()
      this.activities.forEach(element => {
        if (element.type === 'interactions') {
          this.interactionsData.push(element)
          this.hasIteractions = true
        }
      })
    },
    fillChartData() {
      if (this.hasIteractions) {
        let labels = new Array()
        let metadata = new Array()
        let backgroundColor = new Array()
        const uniqueAgents = new Multiset()

        let data = new Array()
        let max = 0
        this.interactionsData.forEach(element => {
          labels.push(element.name)
          backgroundColor.push(getRandomColorFromList(backgroundColor))
          data.push(element.interactions.length)

          if (element.interactions.length > max) {
            max = element.interactions.length
          }

          element.interactions.forEach(intElem => {
            uniqueAgents.add(intElem.name)

            // if (intElem.duration) {
            //   if (this.totalDuration == null) {
            //     this.totalDuration = moment.duration(intElem.duration)
            //   } else {
            //     this.totalDuration = moment
            //       .duration(intElem.duration)
            //       .add(this.totalDuration)
            //   }
            // }
          })
        })

        // set totals
        //this.totalDuration = getDuration(this.totalDuration)
        this.uniqueAgentsCount = uniqueAgents.size

        this.chartOptions = {
          layout: {
            padding: {
              right: 10,
              bottom: 20,
              top: 10
            }
          },
          legend: {
            display: false
          },
          hover: {
            onHover: function(e) {
              e.target.style.cursor = 'pointer'
            }
          },
          onClick: this.onClickInteraction,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            position: 'nearest',
            callbacks: {
              title: function(tooltipItem, data) {
                return ellipsisLongText(
                  data['labels'][tooltipItem[0]['index']],
                  31
                )
              },
              label: function(tooltipItem, data) {
                const metadata = data['metadata']
                const intData = _.find(metadata, {
                  name: tooltipItem.label
                })
                let toolTip = new Array()
                if (intData !== undefined && intData != null) {
                  intData.interactions.forEach(element => {
                    if (toolTip.length < TOTAL_ITEMS) {
                      toolTip.push(ellipsisLongText(element.name, 31))
                    }
                  })

                  if (intData.interactions.length > TOTAL_ITEMS) {
                    const diff = intData.interactions.length - TOTAL_ITEMS
                    toolTip.push(`and ${diff} more`)
                  }
                }
                return toolTip
              }
            },
            backgroundColor: '#FFF',
            titleFontSize: 10,
            titleFontColor: '#000',
            bodyFontColor: '#000',
            bodyFontSize: 12,
            displayColors: false,
            borderWidth: 0.2,
            borderColor: '#000',
            hoverBorderColor: '#000',
            hoverBorderWidth: 10
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  min: 0,
                  max: max,
                  stepSize: 1
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Count'
                }
              }
            ],
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Interactions'
                },
                stacked: true,
                gridLines: {
                  display: false
                }
              }
            ]
          }
        }

        this.chartData = {
          labels: labels,
          metadata: this.interactionsData,
          datasets: [
            {
              backgroundColor: backgroundColor,
              data: data
            }
          ]
        }
      }
    }
  }
}
</script>

<style></style>
